import withResponsive from '../hoc/withResponsive'
import Swiper from 'swiper/dist/js/swiper.min.js'

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default withResponsive({
  name: 'slider-events',

  componentDidMount () {
    console.log('ta mere')
    setTimeout(() => {
      this.swiper = new Swiper(this.el.querySelector('.swiper-container'), {
        direction: 'horizontal',
        speed: 600,
        loop: false,
        navigation: {
          nextEl: '.swiper-cards-button-next',
          prevEl: '.swiper-cards-button-prev',
        },
        pagination: {
          el: '.swiper-cards-pagination',
          type: 'bullets',
          bulletElement: 'li',
        },
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
          // when window width is >= 768px
          769: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        },
      })
    }, 2000)
  },
})
